import chartStyle from '@shopify/polaris-viz/build/esm/styles.css?url';
import { PolarisVizProvider } from '@shopify/polaris-viz';

interface PAChartProviderProps {
  children: React.ReactNode;
  minHeight?: number;
}

export const PAChartProvider = ({ children, minHeight = 219 }: PAChartProviderProps) => {
  return (
    <>
      <link rel="stylesheet" href={chartStyle} />
      <PolarisVizProvider
        themes={{
          Light: {
            chartContainer: {
              minHeight,
            },
            grid: {
              horizontalOverflow: true,
              verticalOverflow: true,
              horizontalMargin: 0,
            },
            seriesColors: {},
          },
        }}
      >
        {children}
      </PolarisVizProvider>
    </>
  );
};
